<template>
  <div class="set-record-name" @mousedown.stop>
    <el-dialog
      v-bind="dialogProps"
      @close="close()"
      @open="onOpenDialog()"
      ref="dialogRef"
    >
      <div class="dialog__header" slot="title">
        录音重命名
        <div class="dialog__close" @click="close()">
          <i class="icon-popup-close"></i>
        </div>
      </div>

      <!-- 命名录音 -->
      <div class="dialog__body">
        <name-content ref="contentRef"></name-content>
      </div>

      <div class="dialog__footer" slot="footer">
        <div class="btns-wrapper">
          <div class="submit" @click="onSubmit()">
            确定
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import nameContent from './generateVoice/nameContent'
export default {
  components: {
    nameContent,
  },
  props: {
    visible: Boolean,
  },
  data () {
    return {

    }
  },
  computed: {
    dialogProps () {
      let {
        visible
      } = this;

      return {
        visible,
        width: '890px',
        'modal-append-to-body': false,
        'show-close': false,
        'top': this.dialogToTop,
      }
    },
    ...mapGetters([
      'Window_Size',
      'TOOL',
      'TypeOfSetRecordName',
      'UpdatingRecordId',
    ])
  },
  mounted () {

  },
  methods: {
    close () {
      this.$emit('closeDialog');
    },
    onOpenDialog () {
      this.setDialogTop();
      this.$bus.emit('nameContent.clearInput');
    },
    setDialogTop () {
      this.$nextTick(() => {
        let parts = this.Window_Size.height - this.$refs.dialogRef.$refs.dialog.offsetHeight
        let top = parts > 0 ? parts / 2 : 60;
        this.dialogToTop = top + 'px';
      });
    },
    onSubmit () {
      let {contentRef} = this.$refs;
      let pass = contentRef.input.validate();
      if (pass) {
        this.$store.commit('save_SoundRecord', {
          uploadingName: contentRef.input.value,
        });
        this.$bus.emit('sendRecordName', {
          name: contentRef.input.value,
          type: this.TypeOfSetRecordName,
          id: this.UpdatingRecordId,
        });
        this.close();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../style/colors";
.dialog {
  &__close {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    right: 0;
    width: 40px;
    height: 40px;
    cursor: pointer;
  }
  &__header {
    position: relative;
    height: 40px;
    line-height: 40px;
    background-color: $c8;
    border-radius: 4px 4px 0 0;
    text-align: left;
    text-indent: 1.5em;
  }
  &__body {
    padding: 44px 44px 0;
  }
  &__footer {
    padding-top: 50px;
    padding-bottom: 50px;
  }
}

.btns-wrapper {
  display: flex;
  justify-content: center;
}

.submit {
  width: 160px;
  height: 40px;
  border-radius: 8px;
  background-color: $c2;
  color: $c0;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/emodal/setUploadRecordName.vue